import { Box, Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useSingleNivel } from "../../../context/SuperAdmin/OASContexts/SingleNivelContext";
import { Spinner } from "../../../components/Loading/Spinner";
import HeaderSingleNivel from "../../../components/Table/OAS/SingleNivel/HeaderSingleNivel";
import SingleNivelTable from "../../../components/Table/OAS/SingleNivel/SingleNivelTable";
import AddNivelAsignsModal from "../../../components/Table/OAS/SingleNivel/AddNivelAsignsModal";
import DeleteNivelAsignModal from "../../../components/Table/OAS/SingleNivel/DeleteNivelAsignModal";

const SingleNivelPage = () => {
  const navigate = useNavigate();
  const { isLoadingInfo, nivel } = useSingleNivel();

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Boton para volver */}
      <Grid item>
        <Button onClick={() => navigate(-1)} sx={{ color: "#336B87" }}>
          <ArrowBackOutlinedIcon />
          Volver
        </Button>
      </Grid>

      {isLoadingInfo ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Título */}
          <Grid item>
            <Typography
              variant={"h4"}
              sx={{ color: "#005559", fontSize: "30px" }}
            >
              <b>Nivel</b> | {nivel?.nombre}
            </Typography>
          </Grid>

          {/* Linea divisoria */}
          <Grid item>
            <Box
              sx={{ height: "1px", width: 1, border: "1px solid #005559" }}
            ></Box>
          </Grid>

          {/* Agregar o eliminar asignaturas en nivel */}
          <Grid item>
            <HeaderSingleNivel />
          </Grid>

          {/* Tabla de asignaturas en nivel */}
          <Grid item>
            <SingleNivelTable />
          </Grid>

          {/* Modal para agregar asignaturas a un nivel */}
          <Grid item>
            <AddNivelAsignsModal />
          </Grid>

          {/* Modal para confirmar eliminar asignaturas de un nivel */}
          <Grid item>
            <DeleteNivelAsignModal />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SingleNivelPage;
